import { IAllPrivateRoutes } from "components/routes/app_routes";
import Register from "../screen";

export const RegisterRoutes: IAllPrivateRoutes[] =
  process.env.REACT_APP_PAPS_REGISTER === "true"
    ? [{ label: "Register", pathName: "/register", routeElement: Register }]
    : [];
